import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MG',
    quote: 'Organicé toda la dinámica familiar en una tarde. Las rutinas visuales cambiaron nuestras mañanas para siempre.',
    author: 'Marcela G., Córdoba',
    role: 'Mamá de Tomás, 8 años'
  }, {
    initials: 'LP',
    quote: 'El Tomo Clínico me dio el criterio para hablar con los médicos y la escuela sin sentirme perdida. Vale cada peso.',
    author: 'Laura P., Rosario',
    role: 'Mamá de Sofía, 10 años'
  }, {
    initials: 'RM',
    quote: 'Las crisis en casa bajaron un 60% en el primer mes. El protocolo de emergencia lo tengo pegado en la heladera.',
    author: 'Roberto M., Buenos Aires',
    role: 'Papá de Mateo, 7 años'
  }];
  return <section className="py-20 px-4 bg-slate-950" data-id="element-353">
      <div className="max-w-6xl mx-auto" data-id="element-354">
        <div className="text-center mb-12" data-id="element-355">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-356">
            💬 LO QUE DICEN LAS FAMILIAS
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full" data-id="element-357"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-358">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-slate-900 border border-slate-800 rounded-2xl p-8 relative hover:border-amber-500/30 transition-colors" data-id="element-359">
              <div className="flex items-center gap-4 mb-6" data-id="element-360">
                <div className="w-12 h-12 bg-amber-500/10 text-amber-400 rounded-full flex items-center justify-center font-bold text-xl border border-amber-500/20" data-id="element-361">
                  {t.initials}
                </div>
                <div className="flex text-amber-400" data-id="element-362">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-363" />)}
                </div>
              </div>
              <p className="text-slate-300 text-lg italic mb-6 leading-relaxed" data-id="element-364">
                "{t.quote}"
              </p>
              <div data-id="element-365">
                <p className="text-white font-bold" data-id="element-366">{t.author}</p>
                <p className="text-slate-500 text-sm" data-id="element-367">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}